angular
	.module 'App.Repository'
	.factory 'ProductDataRepository', ['BaseRepository', (BaseRepository) ->
		class ProductDataRepository extends BaseRepository
			@resource = '/product_data'
			@isRestricted = true

		return new ProductDataRepository
	]
